<template>
  <div class="animated fadeIn">
    <b-row  v-if="loading && !message">
      <div class="sk-double-bounce">
        <div class="sk-child sk-double-bounce1"></div>
        <div class="sk-child sk-double-bounce2"></div>
      </div>
    </b-row>

    <b-row v-else>

      <b-col lg="6" style="display:block; text-align:center;padding-bottom:15px;font-size:14px;">
        <b-list-group style="border:1px solid black">
          <b-list-group-item class="bg-darker d-flex justify-content-between align-items-center">
            FNSID
            <b>FNS123123</b>
          </b-list-group-item>

          <b-list-group-item class="bg-darker d-flex justify-content-between align-items-center">
            RANUM
            <b>251785</b>
          </b-list-group-item>

          <b-list-group-item class="bg-darker d-flex justify-content-between align-items-center">
            RANUM
            <b>251785</b>
          </b-list-group-item>

          <b-list-group-item class="bg-darker d-flex justify-content-between align-items-center">
            CUSTOMER
            <b>Wide Open West</b>
          </b-list-group-item>

          <b-list-group-item class="bg-darker d-flex justify-content-between align-items-center">
            LOCATION
            <b>Knoxvile</b>
          </b-list-group-item>

          <b-list-group-item class="bg-darker d-flex justify-content-between align-items-center">
            CURRENT LOCATION
            <b>Shipped</b>
          </b-list-group-item>

          <b-list-group-item class="bg-darker d-flex justify-content-between align-items-center">
            PRODUCT MODEL
            <b>TM2-1350</b>
          </b-list-group-item>

          <b-list-group-item class="bg-darker d-flex justify-content-between align-items-center">
            TRACKING (IN)
            <b>FNS_pick_up</b>
          </b-list-group-item>

          <b-list-group-item class="bg-darker d-flex justify-content-between align-items-center">
            TRACKING (OUT)
            <b>FNS Delivery</b>
          </b-list-group-item>
        </b-list-group>
      </b-col>

      <b-col lg="6">
        <b-carousel
          id="carousel-1"
          v-model="slide"
          :interval="4000"
          controls
          indicators
          background="rgb(52 59 65)"
          img-height="415px"
          style="text-shadow: 1px 1px 2px #333; height: 415px"
          @sliding-start="onSlideStart"
          @sliding-end="onSlideEnd"
        >

          <b-carousel-slide style="height:415px; background-size:cover" img-src="https://fibernode.com/storage/scanned-data/ATS072938-202313-01.JPG"></b-carousel-slide>
          <b-carousel-slide style="height:415px; background-size:cover" img-src="https://picsum.photos/1024/680/?image=52"></b-carousel-slide>
          <b-carousel-slide style="height:415px; background-size:cover" img-src="https://picsum.photos/1024/680/?image=52"></b-carousel-slide>
          <b-carousel-slide style="height:415px; background-size:cover" img-src="https://picsum.photos/1024/680/?image=52"></b-carousel-slide>

        </b-carousel>

      </b-col>

      <b-col lg="12" class="mt-3">
        <div class="accordion" role="tablist">
          <b-card no-body class="mb-1">
            <b-card-header header-tag="header" class="p-1" role="tab">
              <b-button block v-b-toggle.accordion-1 variant="dark">Scan Information</b-button>
            </b-card-header>
            <b-collapse id="accordion-1" visible accordion="my-accordion" role="tabpanel">
              <b-card-body>
                <b-card-text>Work Summary</b-card-text>
                <b-list-group style="border:1px solid black">
                  <b-list-group-item class="bg-darker d-flex justify-content-between align-items-center">
                    <img style="width:50px; border-radius:500; height: 50px; background-size:cover"
                         src="https://www.fibernode.com/tracker_private/images/people/1172.JPG" />
                    <b>Eric Sims</b>
                    Receiving
                    <span>2021-12-09</span>
                  </b-list-group-item>
                </b-list-group>
              </b-card-body>
            </b-collapse>
          </b-card>

          <b-card no-body class="mb-1">
            <b-card-header header-tag="header" class="p-1" role="tab">
              <b-button block v-b-toggle.accordion-2 variant="dark">Comments</b-button>
            </b-card-header>
            <b-collapse id="accordion-2" accordion="my-accordion" role="tabpanel">
              <b-card-body>
                <b-card-text>Comments</b-card-text>
                <b-list-group style="border:1px solid black">
                  <b-list-group-item class="bg-darker d-flex align-items-center">
                    <div><img style="width:50px; border-radius:500; height: 50px; background-size:cover"
                              src="https://www.fibernode.com/tracker_private/images/people/1172.JPG" />
                      <b style="margin-left:30px;margin-right: 50px">Eric Sims</b></div>
                    <span>Testing testing comment </span>
                  </b-list-group-item>
                </b-list-group>
              </b-card-body>
            </b-collapse>
          </b-card>

          <b-card no-body class="mb-1">
            <b-card-header header-tag="header" class="p-1" role="tab">
              <b-button block v-b-toggle.accordion-3 variant="dark">Repair Information</b-button>
            </b-card-header>
            <b-collapse id="accordion-3" accordion="my-accordion" role="tabpanel">
              <b-card-body>
                <b-card-text>Repair History </b-card-text>
                <b-list-group style="border:1px solid black">
                  <b-list-group-item class="bg-darker d-flex justify-content-between align-items-center">
                    <span>FNSID: <b>ATS098223-01</b></span>
                    <span>FNSRA: <b>2020134</b></span>
                    <span>RECEIVED: <b>2021-12-09</b></span>
                    <span>COMPLAINT: <b>No data</b></span>
                  </b-list-group-item>
                </b-list-group>
              </b-card-body>
            </b-collapse>
          </b-card>

          <b-card no-body class="mb-1">
            <b-card-header header-tag="header" class="p-1" role="tab">
              <b-button block v-b-toggle.accordion-4 variant="dark">Materials/Part Used</b-button>
            </b-card-header>
            <b-collapse id="accordion-4" accordion="my-accordion" role="tabpanel">
              <b-card-body>
                <b-card-text>Materials/Parts Used</b-card-text>
              </b-card-body>
            </b-collapse>
          </b-card>

          <b-card no-body class="mb-1">
            <b-card-header header-tag="header" class="p-1" role="tab">
              <b-button block v-b-toggle.accordion-5 variant="dark">PTDR</b-button>
            </b-card-header>
            <b-collapse id="accordion-5" accordion="my-accordion" role="tabpanel">
              <b-card-body>
                <b-card-text>PTDR</b-card-text>
              </b-card-body>
            </b-collapse>
          </b-card>

          <b-card no-body class="mb-1">
            <b-card-header header-tag="header" class="p-1" role="tab">
              <b-button block v-b-toggle.accordion-6 variant="dark">Receiving Images</b-button>
            </b-card-header>
            <b-collapse id="accordion-6" accordion="my-accordion" role="tabpanel">
              <b-card-body>
                <b-card-text>Receiving Images</b-card-text>
              </b-card-body>
            </b-collapse>
          </b-card>

          <b-card no-body class="mb-1">
            <b-card-header header-tag="header" class="p-1" role="tab">
              <b-button block v-b-toggle.accordion-7 variant="dark">QC/Failure Checklist</b-button>
            </b-card-header>
            <b-collapse id="accordion-7" accordion="my-accordion" role="tabpanel">
              <b-card-body>
                <b-card-text>QC/Failure Checklist</b-card-text>
              </b-card-body>
            </b-collapse>
          </b-card>
        </div>
      </b-col>

    </b-row>
  </div>
</template>


<script>
import cTable from "./Table.vue";

export default {
  name: "tables",
  components: { cTable },
  data: () => {
    return {
      loading: false,
      total: null,
      message: null,
      data: [],
      fields: [
        { key: "fnsid", label: "FNSID", sortable: true },
        { key: "fnsra", label: "RANUM", sortable: true },
        { key: "sernm", label: "Serial#" },
        { key: "pMake", label: "Manufacturer" },
        { key: "pMode", label: "Model" },
        { key: "shipDate", label: "Ship Date", formatter: (value, key, item) => {
            return item.shipDate ? item.shipDate.slice(5, 7) + '/' + item.shipDate.slice(8, 10) + '/' + item.shipDate.slice(0, 4) : null
          } },
        { key: "locat", label: "Location" },
        { key: "price", label: "Price" },
        { key: "pod", label: "POD" },
      ]
    }
  },
  watch: {
    $route (to, from) {
      this.fetchData()
    }
  },
  methods: {
    fetchData() {
      this.message = null;
      this.loading = true;
      let params = {};
      params = {
        fnsid: this.$route.query.fnsid,
      };
      this.$http
        .get("api/aoi/tables/search.php", { params })
        .then(
          res => {
            if(res.data.message) {
              this.message = 'Nothing found.'
            } else {
              this.data = res.data.records;
              this.total = res.data.records.length;
              this.loading = false;
            }
          },
          err => {
            console.log(err);
          }
        );
    }
  },
  mounted() {
    this.fetchData()
  }
}
</script>

<style scoped>
.bg-darker {
  background: #343b41 !important;
}
</style>
